module.exports = __webpack_public_path__ + "img/Jazmin Llana.bd5df653.jpg";